module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8tYiY"))).then(() => parcelRequire('d0iPb'));